
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  feedback: true,
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  description: "Use Zero Hash with Plaid Auth to embed bank account linking for ACH-funded crypto trades"
};
export const partnerProps = {
  partner: 'Zero Hash',
  clientLibrary: 'zero_hash',
  subtitle: metadata.description,
  registrationUrl: 'https://zerohash.com/contact/',
  apiUrl: 'https://docs.zerohash.com/web/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Zero Hash have partnered to enable end users to instantly connect their bank accounts to pre-fund a
wallet or facilitate buy and sell crypto trades with ACH payments. Zero Hash’s clients can use Plaid Link to
instantly authenticate a user’s financial account and generate a Plaid processor token to seamlessly and securely
exchange user bank account information, without having to store any sensitive data. The processor token enables
Zero Hash to initiate transaction requests directly from Plaid so that customers can execute ACH payments via
Zero Hash’s API.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
